module.exports = __webpack_public_path__ + "static/img/01.8962112.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/huegler/01.jpg
// module id = 375
// module chunks = 1